import { MdErrorOutline, MdOutlineCheckCircle, MdOutlineWarningAmber } from '../Icon/reactIcons';
import styled from 'styled-components';
import theme from '../../../theme';
import { FlexContainer } from '../Container';
import { Logo } from '../Logo';
import { Card, Container, Message, Title } from './style';
export type StatusProps = {
  title: string;
  description: string[];
  buttons?: React.ReactNode[];
};

type Props = {
  status: 'Error' | 'Success' | 'Warning';
} & StatusProps;

const FlexLogo = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${(p) => p.theme.spacing.sm};
`;

const Status: React.FC<Props> = ({ status, title, description, buttons }: Props) => {
  const icon = () => {
    // No need to make this more complex yet.
    if (status === 'Error') return <MdErrorOutline size={40} color={theme.colors.general.error} />;
    if (status === 'Success') return <MdOutlineCheckCircle size={40} color={theme.colors.general.success} />;
    return <MdOutlineWarningAmber size={40} color={theme.colors.general.warning} />;
  };
  return (
    <Container>
      <Card>
        <FlexLogo>
          <Logo width={100} />
        </FlexLogo>
        <FlexContainer align="center" justify="center">
          {icon()}
        </FlexContainer>
        <Title>{title}</Title>
        {description.map((desc, index) => (
          <Message key={`success-${index}`}>{desc}</Message>
        ))}
        {buttons && <FlexContainer justify="center">{buttons.map((b) => b)}</FlexContainer>}
      </Card>
    </Container>
  );
};

export default Status;
